import NotificationsOutlinedIcon from '@material-ui/icons/NotificationsOutlined';
import VehicleBulletinsTab from '../components/add-edit-vehicle/VehicleBulletinsTab';
import DirectionsCarOutlinedIcon from '@material-ui/icons/DirectionsCarOutlined';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import VehicleRegistrationsTab from '../components/add-edit-vehicle/VehicleRegistrationsTab';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import VehicleDetailsForm from '../components/add-edit-vehicle/VehicleDetailsForm';
import VehicleTowingTab from '../components/add-edit-vehicle/VehicleTowingTab';
import VehicleAttachmentsTab from '../components/add-edit-vehicle/VehicleAttachmentsTab';
import { VEHICLE_TAB_KEYS } from './addVehicleFormConstants';

export const VehicleSidebarMenuItems = [
  {
    key: VEHICLE_TAB_KEYS.EDIT,
    label: 'Edit Vehicle',
    icon: DirectionsCarOutlinedIcon,
    content: VehicleDetailsForm,
  },

  {
    key: VEHICLE_TAB_KEYS.REGISTRATIONS,
    label: 'Registrations',
    icon: AssignmentOutlinedIcon,
    content: VehicleRegistrationsTab,
  },
  {
    key: VEHICLE_TAB_KEYS.TOWING,
    label: 'Towing',
    icon: LocalShippingOutlinedIcon,
    content: VehicleTowingTab,
  },
  {
    key: VEHICLE_TAB_KEYS.ATTACHMENTS,
    label: 'Attachments',
    icon: AttachFileIcon,
    content: VehicleAttachmentsTab,
  },
  {
    key: VEHICLE_TAB_KEYS.BULLETINS,
    label: 'Bulletins',
    icon: NotificationsOutlinedIcon,
    content: VehicleBulletinsTab,
  },
];

export const VehicleSidebarGroups = [
  { key: 'vehicle', label: 'Vehicle', items: VehicleSidebarMenuItems },
];

export const getSelectedVehicleMenu = (key) =>
  VehicleSidebarMenuItems.find((item) => item.key === key) || null;
